module.exports = __webpack_public_path__ + "static/media/mahesh.f94f84b9.png";